// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: "Fira Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5f6;
}

code {
  font-family: "Fira Sans", sans-serif;
}

*:focus {
  outline: none;
}

textarea::placeholder {
  color: #b4b2b2d2;
}
/***/
.marker {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  align-items: center;
  /* width: 150px; */
}

.marker-text {
  font-weight: 600;
}
.scroll-invisible {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scroll-invisible::-webkit-scrollbar {
  display: none;
}

/** */
.tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #f39325 transparent transparent transparent;
}

input[type="number"] {
  margin: 0;
}

/* Remove scroll from the number input */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA,IAAI;AACJ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,aAAa;AACf;;AAEA,KAAK;AACL;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,SAAS;AACX;;AAEA,wCAAwC;AACxC;;EAEE,8CAA8C;EAC9C,wBAAwB;EACxB,SAAS,EAAE,uEAAuE;AACpF;;AAEA;EACE,0BAA0B,EAAE,YAAY;AAC1C","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: \"Fira Sans\", sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background: #f5f5f6;\r\n}\r\n\r\ncode {\r\n  font-family: \"Fira Sans\", sans-serif;\r\n}\r\n\r\n*:focus {\r\n  outline: none;\r\n}\r\n\r\ntextarea::placeholder {\r\n  color: #b4b2b2d2;\r\n}\r\n/***/\r\n.marker {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* width: 150px; */\r\n}\r\n\r\n.marker-text {\r\n  font-weight: 600;\r\n}\r\n.scroll-invisible {\r\n  -ms-overflow-style: none; /* IE and Edge */\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n.scroll-invisible::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n/** */\r\n.tooltiptext::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: #f39325 transparent transparent transparent;\r\n}\r\n\r\ninput[type=\"number\"] {\r\n  margin: 0;\r\n}\r\n\r\n/* Remove scroll from the number input */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  /* display: none; <- Crashes Chrome on hover */\r\n  -webkit-appearance: none;\r\n  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\r\n}\r\n\r\ninput[type=\"number\"] {\r\n  -moz-appearance: textfield; /* Firefox */\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
